import React, { useState, useEffect, useCallback } from 'react';
import { DefaultButton } from 'office-ui-fabric-react';
import { Col } from 'react-flexbox-grid';
import { useVerificarGenerarTransaccion } from '../../hooks/powerpay';
import logoPowepay from '../../images/powerpay.png';

export const PagarPowerpay = ({jwt, idOrden, studentCode, mostrarPowerpayVencido, totalPago}) => {

  const [mostrarBotonPowerpay, setMostrarBotonPowerpay] = useState(true);
  const [pagar, setPagar] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const {isLoading, urlPowerpay, expiredPowerpay, hasError, mostrarPowerpay, montoMinimoPp, montoMaximoPp} = useVerificarGenerarTransaccion(jwt, idOrden, studentCode, pagar);  

  const showExpiradoPowerpay = useCallback(mostrarPowerpayVencido, []);

  useEffect(() => {
    setMostrarBotonPowerpay(mostrarPowerpay);
  }, [mostrarPowerpay])
  

  useEffect(()=>{
    if(!isLoading) setPagar(false);    
  }, [isLoading])

  useEffect(()=>{
    if(!!urlPowerpay) {
      window.location = urlPowerpay;
      // window.open(urlPowerpay, "_blank")
    }    
  },[urlPowerpay])

  useEffect(()=>{
    if(expiredPowerpay) {
      showExpiradoPowerpay();
      setDisableButton(false);
    }    
  },[expiredPowerpay, showExpiradoPowerpay])

  useEffect(() => {
    if(hasError) setDisableButton(false);
  }, [hasError])
  

  const handlePowerpay = () => {
    if(totalPago >= montoMinimoPp && totalPago <= montoMaximoPp){      
      setPagar(true);
      setDisableButton(true);
    }else{
      alert(`“Para pagar en cuotas con Powerpay, debes tener una deuda entre S/ ${montoMinimoPp} y S/ ${montoMaximoPp} soles”`)    
    }
  }

  return (
    <>
      {isLoading || !!urlPowerpay ? <div className="preloader"></div> : null}
      {
        mostrarBotonPowerpay && 
        <Col className="border-left" xs={12} sm={3}>
          <DefaultButton
            className="btn-powerpay modal-opener default"
            text="Powerpay"
            onClick={handlePowerpay}
            disabled={disableButton}
          ></DefaultButton>
          <br></br>
          <br></br>
          <img
            src={logoPowepay}
            alt="LogoPowerpay"
            width="100%"
          ></img>
        </Col>
      }
    </>
  )
}